import React from "react";

const OurServices = () => {
  return (
    <section id="services" className="py-5 py-lg-5">
      <div className="container py-4">
        <div className="text-center mb-5">
          <span className="hero-badge bg-gold bg-opacity-10">
            <i className="fas fa-cogs me-2" /> What We Offer
          </span>
          <h2 className="display-5 fw-bold mt-3" style={{ color: "#0A2540" }}>
            Complete Financial Inclusion Suite
          </h2>
          <p className="lead text-muted mx-auto" style={{ maxWidth: 700 }}>
            Empowering BC Agents with cutting-edge banking services to serve
            unbanked and underbanked communities.
          </p>
        </div>
        <div className="row g-4">
          <div className="col-md-6 col-lg-4">
            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-fingerprint" />
              </div>
              <h4 className="fw-bold mb-3">
                AEPS (Aadhaar Enabled Payment System)
              </h4>
              <p className="text-muted">
                Seamless banking services using Aadhaar authentication. Cash
                withdrawal, balance inquiry, mini statement at your BC outlet.
              </p>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-exchange-alt" />
              </div>
              <h4 className="fw-bold mb-3">DMT (Domestic Money Transfer)</h4>
              <p className="text-muted">
                Instant money transfer to any bank account across India with a
                fully RBI-compliant DMT service.
              </p>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-truck" />
              </div>
              <h4 className="fw-bold mb-3">CMS (Cash Management Services)</h4>
              <p className="text-muted">
                Efficient cash collection, delivery and management solutions for
                businesses and retail agents.
              </p>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-credit-card" />
              </div>
              <h4 className="fw-bold mb-3">Micro ATM</h4>
              <p className="text-muted">
                Enable cash withdrawal through debit card. Earn commissions on
                every transaction.
              </p>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="service-card">
              <div className="service-icon">
                <i className="fa-solid fa-qrcode" />
              </div>
              <h4 className="fw-bold mb-3">UPI Cash Point (Coming Soon)</h4>
              <p className="text-muted">
                Enable cash withdrawal through UPI QR at your retail point. Earn
                commissions on every transaction.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurServices;
